export default "__VITE_ASSET__b1d23189__"